import React from "react";

// components
import DetailContent from "src/components/Blog/DetailContent/DetailContent";

const BlogDetail = () => {
  return <DetailContent />;
};

export default BlogDetail;
